// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"ee836ae8","57":"46426ad1","90":"d6706682","95":"d744fd01","108":"55fd7fde","474":"37fdfc3a","604":"cf0fbcac","937":"4e5619f1","981":"5a76fafe"}[chunkId] + ".chunk.js";
};